import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-6 py-6 bg-violet-700 rounded-lg md:py-12 md:px-12 lg:py-16 lg:px-16 xl:flex xl:items-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl leading-8 font-extrabold tracking-tight text-white sm:text-3xl sm:leading-9" }, " Thanks for signing up and we look forward to working with you! ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "xl:w-0 xl:flex-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl leading-8 font-extrabold tracking-tight text-white sm:text-3xl sm:leading-9" }, " Want to be a beta tester? ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt-3 max-w-3xl text-lg leading-6 text-violet-200",
  id: "newsletter-headline"
}, " Inciteful is changing every day. Stay up to date, get early access to new features, and have a say in what we develop. ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "mt-8 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button-light-violet w-full px-5 py-3 leading-6 text-base" }, " Join ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true),
    (!_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("form", {
            class: "sm:flex",
            "aria-labelledby": "newsletter-headline",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              "aria-label": "Email address",
              type: "email",
              required: "",
              class: "appearance-none w-full px-5 py-3 border border-transparent text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 transition duration-150 ease-in-out",
              placeholder: "Enter your email"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _hoisted_10
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}